export const documentTypes = [
    {
        name: "Cédula",
        value: "CC"
    },
    {
        name: "Pasaporte",
        value: "PAP"
    },
    {
        name: "Cédula de extranjería",
        value: "CE"
    }
];

export const userTypes = [
    "Abogado", "Administrador",
];